import { FETCH_ALL_NOTIFICATIONS_PENDING, FETCH_ALL_NOTIFICATIONS_SUCCESS } from "../types";

const initialState = {
    notficationsList: [],
    notficationsListStatus: '',
}
const notificationReducer = (state = initialState, action = '') => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_ALL_NOTIFICATIONS_PENDING:
            return {
                ...state,
                notficationsListStatus: 'PENDING',
                notficationsList: [],
            };
        case FETCH_ALL_NOTIFICATIONS_SUCCESS:
            return {
                ...state,
                notficationsListStatus: 'SUCCESS',
                notficationsList: payload,
            };
        default:
            return state;
    }
}
export default notificationReducer;